import React, { lazy, Suspense } from 'react';

import { EventProvider } from '@clients/ek/providers/EventProvider/EventProvider';

import LoadingProgress from '@components/LoadingProgress';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { env } from 'env';

const AvaturnModal = lazy(
  () => import('@clients/ek/features/avaturn/components/AvaturnModal'),
);

const { REACT_APP_FEATURE_AVATURN } = env;

const EventPageWrapper = ({ children }: { children: JSX.Element }) => {
  const { showAvaturnModal } = useMytaverseEvent();

  return (
    <EventProvider>
      {children}
      {showAvaturnModal && REACT_APP_FEATURE_AVATURN === 'true' && (
        <Suspense fallback={<LoadingProgress />}>
          <AvaturnModal />
        </Suspense>
      )}
    </EventProvider>
  );
};

export default EventPageWrapper;
